import clsxm from "@/lib/clsxm"

import Heading from "@/components/common/Heading/Heading"
import Icon from "@/components/common/Icon/Icon"

type SummaryBlockProps = {
  children?: React.ReactNode
  className?: string
  icon?: React.ElementType
  style?: `light-gray` | `white`
  title?: string
}

export const SummaryBlock = ({
  children,
  className,
  icon,
  style = `light-gray`,
  title,
}: SummaryBlockProps) => {
  return (
    <div
      className={clsxm(
        `flex space-x-3 rounded-lg  p-4`,
        [style === `light-gray` && [`border border-gray-200 bg-gray-50`]],
        [
          style === `white` && [
            `bg-white shadow-[0px_19px_24px_-12px_rgba(0,0,0,0.10)] `,
          ],
        ],
        className
      )}
    >
      {icon && <Icon className={`text-primary-500`} icon={icon} />}

      <div className={`w-full`}>
        {title && (
          <Heading
            className={`mb-1 text-sm font-bold sm:text-base`}
            headingLevel={`p`}
          >
            {title}
          </Heading>
        )}

        <div className={`text-base font-extralight sm:text-xl`}>{children}</div>
      </div>
    </div>
  )
}
